import { LegalLayout, H2, H3 } from "./LegalLayout";

const ANBIETER = {
  name: "Lucas Garrido",
  street: "Pflügersgrundstraße 32-34",
  zip: "68169",
  city: "Mannheim",
  email: "info@gruendio.de",
};

export default function Widerruf() {
  return (
    <LegalLayout title="Widerrufsbelehrung & Muster-Widerrufsformular" testid="widerruf-page">
      <H2>Widerrufsbelehrung</H2>

      <H3>Widerrufsrecht</H3>
      <p>
        Du hast das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die
        Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.
      </p>
      <p>
        Um dein Widerrufsrecht auszuüben, musst du uns
      </p>
      <p>
        <strong>{ANBIETER.name}</strong>
        <br />
        {ANBIETER.street}
        <br />
        {ANBIETER.zip} {ANBIETER.city}
        <br />
        E-Mail: {ANBIETER.email}
      </p>
      <p>
        mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über deinen
        Entschluss, diesen Vertrag zu widerrufen, informieren. Du kannst dafür das beigefügte
        Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
      </p>
      <p>
        Zur Wahrung der Widerrufsfrist reicht es aus, dass du die Mitteilung über die Ausübung des Widerrufsrechts vor
        Ablauf der Widerrufsfrist absendest.
      </p>

      <H3>Folgen des Widerrufs</H3>
      <p>
        Wenn du diesen Vertrag widerrufst, haben wir dir alle Zahlungen, die wir von dir erhalten haben, unverzüglich
        und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über deinen Widerruf
        dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das du bei
        der ursprünglichen Transaktion eingesetzt hast, es sei denn, mit dir wurde ausdrücklich etwas anderes
        vereinbart; in keinem Fall werden dir wegen dieser Rückzahlung Entgelte berechnet.
      </p>

      <H3>Vorzeitiges Erlöschen des Widerrufsrechts</H3>
      <p>
        Dein Widerrufsrecht <strong>erlischt</strong> bei einem Vertrag zur Bereitstellung von nicht auf einem
        körperlichen Datenträger befindlichen digitalen Inhalten (z. B. dem digitalen Report als Download) vorzeitig,
        wenn wir mit der Ausführung des Vertrags begonnen haben, nachdem du
      </p>
      <ol className="list-decimal pl-6 space-y-1">
        <li>
          ausdrücklich zugestimmt hast, dass wir mit der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnen,
          und
        </li>
        <li>
          deine Kenntnis davon bestätigt hast, dass du durch deine Zustimmung mit Beginn der Ausführung des Vertrags
          dein Widerrufsrecht verlierst.
        </li>
      </ol>
      <p className="text-slate-500">
        Hinweis: Diese Zustimmung erteilst du im Bestellvorgang über das entsprechende Kontrollkästchen.
      </p>

      <H2>Muster-Widerrufsformular</H2>
      <p className="text-slate-500">
        (Wenn du den Vertrag widerrufen willst, dann fülle bitte dieses Formular aus und sende es zurück.)
      </p>
      <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-3">
        <p>
          An<br />
          <strong>{ANBIETER.name}</strong>, {ANBIETER.street}, {ANBIETER.zip} {ANBIETER.city}, E-Mail: {ANBIETER.email}
        </p>
        <p>
          Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden
          Dienstleistung / des folgenden digitalen Inhalts:
        </p>
        <p>_______________________________________________</p>
        <p>Bestellt am (*) / erhalten am (*): _______________</p>
        <p>Name des/der Verbraucher(s): _______________</p>
        <p>Anschrift des/der Verbraucher(s): _______________</p>
        <p>Datum: _______________</p>
        <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier): _______________</p>
        <p className="text-slate-500">(*) Unzutreffendes streichen.</p>
      </div>
    </LegalLayout>
  );
}
